export const HAULIERS = {
  DPMP: 'dpmp',
  NITRA: 'nitra',
  TRENCIN: 'trencin',
  RUZOMBEROK: 'ruzomberok',
  DPB: 'dpb',
  POLAND: 'poland',
  VISEUDESUS: 'viseudesus',
  DPMO: 'dpmo',
  DPMLB: 'dpmlb',
  JIKORD: 'jikord',
  LOCAL: 'local',
  DPMDAS: 'dpmdas',
  DPMPR: 'dpmpr',
  ADOSA: 'adosa',
} as const;

export const TABLE_TAB_FILTER_STYLES = 'margin-top: -57px; margin-right: -15px;';

export const LEFT_MENU_TAB_INDEX = 100;

export const DEFAULT_COOLDOWN_DAYS = 30;

export const DEFAULT_TAX_PERCENTAGE = 21;

export const PORTABLE_CARD_FINISH_REGISTER_CUSTOMER_ID_SESSION_KEY = 'eshop-portable-card-finish-register-customer-id';
